import BenchlingConfig from 'BenchlingConfig';
import {SectionConfiguration} from 'notebook/ELNConstants';
import EntryExportConfig from 'notebook/entries/EntryExportConfig';
import {
  EditorPropertiesContextInterface,
  getDefaultSectionConfigurationContext,
} from 'notebook/notes/core-ui/NoteContext';
import isConfiguration from 'notebook/util/isConfiguration';
import preferences from 'Preferences';
import memoizeLastCall from 'util/memoizeLastCall';

const IGEM_PREFERENCE_KEY = 'export.is_iGEM';

export const editorPropertiesContextForPrintView = memoizeLastCall(
  (
    fileId: string,
    isExportView: boolean,
    showFormulas: boolean = false,
    skipLiveData: boolean = false
  ): EditorPropertiesContextInterface => ({
    showFormulas,
    fileId,
    highlightCustomColumns: true,
    isExportView,
    isPrintPreviewView: true,
    isConfig: isConfiguration(fileId),
    skipLiveData,
  })
);

export const getExportConfigForMetadataSection = (
  exportConfig: EntryExportConfig | undefined
): EntryExportConfig | undefined => {
  const showGeneratedOnTimestamp = exportConfig?.showGeneratedOnTimestamp ?? true;

  return {
    ...exportConfig,
    showBranding: preferences.get(IGEM_PREFERENCE_KEY),
    // Use exportConfig values if explicitly provided, otherwise fall back to BenchlingConfig
    // This allows incremental exports to suppress review history on subsequent chunks
    showReviewHistory:
      exportConfig?.showReviewHistory ?? BenchlingConfig.ELN_EXPORT_PDF_CONFIG.includeReviewHistoryTable,
    showReviewCommentHistory:
      exportConfig?.showReviewCommentHistory ??
      BenchlingConfig.ELN_EXPORT_PDF_CONFIG.includeCommentsInReviewHistoryTable,
    // exportedOn comes from the print-preview URL; fall back to now for in-app print preview.
    exportedOn:
      BenchlingConfig.ELN_DISABLE_PDF_EXPORT_GENERATED_ON_TIMESTAMP || !showGeneratedOnTimestamp
        ? undefined
        : (exportConfig?.exportedOn ?? new Date().toISOString()),
  };
};

export const getPrinterFriendlySectionConfigurationContext = (
  allowPreamble: boolean
): SectionConfiguration => ({
  // Setting preamble to "true" will hide the first section header.
  allows: {
    ...getDefaultSectionConfigurationContext().allows,
    preamble: allowPreamble,
  },
});
